//
import Menu from './Menu';
import Card from './Card';
import List from './List';
import Paper from './Paper';
import Input from './Input';
import Select from './Select';
import Switch from './Switch';
import Table from './Table';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import Autocomplete from './Autocomplete';
import Pagination from './Pagination';


// ==============================|| COMPONENTS OVERRIDES ||============================== //

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Menu(theme),
    Card(theme),
    List(theme),
    Table(theme),
    Input(theme),
    Select(theme),
    Switch(theme),
    Paper(theme),
    Pagination(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    Autocomplete(theme)
  );
}
